import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleRemoveAttachedDocument(
  task: Identifiable<Task>,
  { elementId }: Boundaries["removeAttachedDocument"]["success"],
): Identifiable<Task> {
  return elementId === task.uuid
    ? {
        ...task,
        attachmentsNbr: task.attachmentsNbr
          ? task.attachmentsNbr - 1
          : task.attachmentsNbr,
      }
    : task;
}

export { handleRemoveAttachedDocument };
